import script from "./GoogleRecaptcha.vue?vue&type=script&lang=ts"
export * from "./GoogleRecaptcha.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__